"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M1.4 4.5L9 1.05l7.6 3.45L9 7.95 1.4 4.5zM8.8.04a.47.47 0 01.4 0l8.44 3.83c.48.22.48 1.04 0 1.26l-2.56 1.16v4.88c0 .32-.03.69-.2 1.06-.16.38-.45.7-.9.97-.88.51-2.39.8-4.96.8-2.6 0-4.1-.39-4.98-.95a2.37 2.37 0 01-.88-.97c-.17-.35-.2-.67-.2-.9V6.3L.36 5.13c-.48-.22-.48-1.04 0-1.26L8.8.04zM3.96 6.76v4.41c0 .15.02.31.1.48.08.16.22.36.53.56.62.4 1.9.79 4.43.79 2.55 0 3.82-.3 4.45-.66.3-.17.43-.35.5-.52.08-.17.1-.38.1-.65V6.74L9.2 8.96a.47.47 0 01-.4 0l-4.84-2.2z"
}));

exports.default = _default;